import { randInt } from '../utils/fractionMath';

const ALLOWED_DENS = [2, 3, 4, 5, 6, 8, 10];

export function generateTopic5Questions(count = 10) {
  const questions = [];
  for (let i = 0; i < count; i++) {
    const den = ALLOWED_DENS[randInt(0, ALLOWED_DENS.length - 1)];
    const num = randInt(1, den - 1); // strictly between 0 and 1

    questions.push({
      id: `t5_${i}`,
      topicId: 5,
      type: 'number_line',
      prompt: `Atrod daļu uz skaitļu taisnes un nospied uz tās!`,
      data: { num, den },
      correctAnswer: { num, den },
    });
  }
  return questions;
}
